import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Modal } from 'react-bootstrap';
import ButtonAccept from 'utils/buttons/ButtonAccept';
import ButtonClose from 'utils/buttons/ButtonClose';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { getRealEstateProjectStats } from 'redux/realEstateSlice';
import ModalButtonsContainer from 'sites/common/ModalButtonsContainer';

const PauseModal = ({ project, setShow, handleStatus }) => {
  const handleClose = () => setShow(false);

  const { realEstate } = useSelector(state => state.realEstate);
  const dispatch = useDispatch();

  const handlePause = async proj => {
    await handleStatus(proj);
    dispatch(getRealEstateProjectStats(realEstate.id));
    handleClose();
  };

  return (
    <>
      <Modal
        keyboard={true}
        show={true}
        onHide={handleClose}
        backdrop="static"
        centered
      >
        <Modal.Header closeButton>
          <FontAwesomeIcon
            icon="fa-pause"
            title="Pausar"
            size="1x"
            style={{ marginRight: 8, color: '#02a8b5' }}
          />

          <Modal.Title>Pausar emprendimiento</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="mb-4">
            El emprendimiento de dirección{' '}
            <b>
              {project.location.street} {project.location.number}
            </b>{' '}
            se pausará y ya no será visible para los clientes.
            <br />
            <br />
            ¿Está seguro de confirmar esta acción?
          </div>

          <ModalButtonsContainer>
            <ButtonClose text="Cancelar" funcion={handleClose} />

            <ButtonAccept
              text="Confirmar"
              funcion={handlePause}
              data={{ id: project._id, status: 'paused' }}
            />
          </ModalButtonsContainer>
        </Modal.Body>
      </Modal>
    </>
  );
};

PauseModal.propTypes = {
  project: PropTypes.object.isRequired,
  setShow: PropTypes.func.isRequired,
  handleStatus: PropTypes.func.isRequired
};

export default PauseModal;
